import type { AssetKind, GateLayer } from '@/types/pulse'

export type StationId = 'chapter_text' | 'screenplay' | 'storyboard' | 'panel_image' | 'audio' | 'video'
export type StationModality = 'text' | 'script' | 'storyboard' | 'image' | 'audio' | 'video'

export interface StationDef {
  id: StationId
  stage: number
  assetType: AssetKind
  qualityGates: readonly GateLayer[]
  upstream: readonly StationId[]
  modality: StationModality
}

export const STATIONS: readonly StationDef[] = [
  {
    id: 'chapter_text',
    stage: 0,
    assetType: 'chapter_text',
    qualityGates: ['L0', 'L1', 'L2'],
    upstream: [],
    modality: 'text',
  },
  {
    id: 'screenplay',
    stage: 1,
    assetType: 'screenplay',
    qualityGates: ['L0'],
    upstream: ['chapter_text'],
    modality: 'script',
  },
  {
    id: 'storyboard',
    stage: 2,
    assetType: 'storyboard',
    qualityGates: ['L0'],
    upstream: ['screenplay'],
    modality: 'storyboard',
  },
  {
    id: 'panel_image',
    stage: 3,
    assetType: 'panel_image',
    qualityGates: ['L0'],
    upstream: ['storyboard'],
    modality: 'image',
  },
  {
    id: 'audio',
    stage: 3,
    assetType: 'audio',
    qualityGates: ['L0', 'L3'],
    upstream: ['screenplay'],
    modality: 'audio',
  },
  {
    id: 'video',
    stage: 3,
    assetType: 'video',
    qualityGates: ['L0'],
    upstream: ['storyboard'],
    modality: 'video',
  },
] as const
